import { Injectable } from '@angular/core';
import { GraphqlService } from 'src/app/services/graphql/graphql.service';

@Injectable({
  providedIn: 'root',
})
export class SearchPermissionsService {
  constructor(private graphql: GraphqlService) {}

  /**
   * Get the list of book permission ids for the current user.
   * @returns {Promise<string[]>} A promise that resolves to an array of unique book permission ids.
   */
  async getBookPermissionsIds(): Promise<string[]> {
    const data = await this.graphql.getMyONBookPermissions();

    const permissionIds = data.reduce((acc, perm) => {
      if (!perm.bookPermissionIds) {
        return acc;
      }

      // bookPermissionIds comes back from the api as a stringified array.
      // This is an expected behavior between snowflakes variant column and hasura.
      let ids = perm.bookPermissionIds;

      // temporarily handle the case where bookPermissionIds is a string
      if (typeof ids === 'string') {
        try {
          ids = JSON.parse(ids);
        } catch (e) {
          console.error('Error parsing bookPermissionIds:', e);
          return acc;
        }
      }

      acc.push(...ids);

      return acc;
    }, [] as string[]);

    return this.uniqueArr(permissionIds);
  }

  private uniqueArr(arr: string[]) {
    return Array.from(new Set(arr));
  }
}
